import { Injectable } from '@angular/core';
import { URLS } from '../constants/constants';
import { HeaderType } from '../enums/enums';
import { FilterModel } from '../interface/interface';
import { VideoPayloadModel } from '../models/video.model';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class VideoService {
  constructor(private http: HttpService) {}

  fetchVideos(filter: FilterModel) {
    return this.http.get(URLS.video, {
      params: {
        headerType: HeaderType.ACCESS,
        search: filter.searchText,
        page: filter.pageNumber,
        limit: filter.limit,
      },
    });
  }

  addVideo(payload: VideoPayloadModel) {
    return this.http.post(`${URLS.video}`, payload, {
      params: { headerType: HeaderType.ACCESS },
    });
  }

  updateVideo(id: string, payload: VideoPayloadModel) {
    return this.http.put(`${URLS.video}/${id}`, payload, {
      params: { headerType: HeaderType.ACCESS },
    });
  }

  deleteVideo(id: string) {
    return this.http.delete(`${URLS.video}/${id}`, {
      params: { headerType: HeaderType.ACCESS },
    });
  }

  fetchVideoById(id: string) {
    return this.http.get(`${URLS.video}/${id}`, {
      params: {
        headerType: HeaderType.ACCESS,
      },
    });
  }
}
